// Liao 2.0 scroll animations + stories playback.
// GSAP + ScrollTrigger are self-hosted theme assets (no CDN at runtime).
// Hooks: [data-liao-reveal] fade-up on enter, [data-liao-parallax] image
// drift (the draft collage's 120%-height images), [data-liao-story-play].
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAnimations() {
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add('liao-reveal-ready');

    document.querySelectorAll('[data-liao-reveal]').forEach(function (el) {
      gsap.fromTo(
        el,
        { opacity: 0, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 82%' },
        }
      );
    });

    document.querySelectorAll('[data-liao-parallax] img').forEach(function (img) {
      gsap.fromTo(
        img,
        { yPercent: 0 },
        {
          yPercent: -14,
          ease: 'none',
          scrollTrigger: {
            trigger: img.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        }
      );
    });
  }

  // Story videos ship preload="none": six HLS testimonials were pulling ~23MB
  // of media segments on every page load, before anyone pressed play. Warm a
  // card to metadata only once it is actually on screen, so click-to-play stays
  // quick without taxing visitors who never reach the carousel.
  function initStoryWarmup() {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    if (typeof IntersectionObserver === 'undefined') return;
    var videos = [].slice.call(
      document.querySelectorAll('.liao-stories__card video[preload="none"]')
    );
    if (!videos.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target;
          io.unobserve(video);
          video.preload = 'metadata';
          video.load();
        });
      },
      { rootMargin: '200px' }
    );
    videos.forEach(function (video) {
      io.observe(video);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-liao-story-play]');
    if (!btn) return;
    var card = btn.closest('.liao-stories__card');
    var video = card && card.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.muted = false;
      video.play();
      btn.style.display = 'none';
      video.addEventListener(
        'ended',
        function () {
          btn.style.display = '';
        },
        { once: true }
      );
      video.addEventListener(
        'click',
        function () {
          video.pause();
          btn.style.display = '';
        },
        { once: true }
      );
    }
  });

  function init() {
    initAnimations();
    initStoryWarmup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
